
import buttonStyles from "./round-button.module.css";


export default function JumpMusic () {



    return (
        <a href={`#Music-Projects`}>
            <div className={`${buttonStyles.toggleButton} ${buttonStyles.jumpButton}`}>
                    < img src="./images/guitar-icon.png" className={buttonStyles.toggleImage} alt="Jump to Music button" />
            </div>
        </a>
    )
}